import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
// INTERFACES
import { ConnectInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentConnect({
	data,
	setData,
}: {
	data: ConnectInterface;
	setData: (newValue: ConnectInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeValue = (newValue: string, variableName: string) => {
		const copy = structuredClone(data);
		if (variableName === "name") {
			copy.name = newValue;
		}
		setData(copy);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<FormInputText
				inputValue={data.name}
				inputLabelName={t("general.hostName")}
				inputOnChange={onChangeValue}
				inputVariableName='name'
				isRequired
				disabledInput={false}
				
			/>
		</div>
	);
}
